module.exports = __webpack_public_path__ + "img/logo.b387f9f6.svg";